import { createSlice, SliceSelectors } from '@reduxjs/toolkit';
import { TVerifyUserErrorCode } from '../../types/joinOtaIndividual/verifyUserErrorCode';
import { TVerifyInsuranceUserErrorCode } from '../../types/activateInsurance/verifyUserErrorCode';

export type TUserVerificationError = TVerifyUserErrorCode | TVerifyInsuranceUserErrorCode;

const initialState: TUserVerificationError | null = null;

const userVerificationErrorSlice = createSlice<
  TUserVerificationError | null,
  {},
  'userVerificationError',
  SliceSelectors<TUserVerificationError | null>,
  'userVerificationError'
>({
  name: 'userVerificationError',
  initialState,
  reducers: {},
});

export const { reducer: userVerificationErrorReducer } = userVerificationErrorSlice;
